import { motion } from "framer-motion";
import { Calendar, MessageCircle, Phone } from "lucide-react";
import { CONTACT } from "@/lib/site";
import { scrollTo } from "./Navbar";

export const CtaBand = () => {
  return (
    <section data-testid="cta-band" className="py-24 lg:py-32 bg-navy relative overflow-hidden grain">
      <div className="blob w-[520px] h-[520px] bg-brand/25 -top-40 -left-20" />
      <div className="blob w-[420px] h-[420px] bg-emerald/20 bottom-0 right-0" style={{ animationDelay: "-8s" }} />
      <div className="relative z-10 max-w-4xl mx-auto px-5 lg:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="font-display font-black text-white tracking-tighter text-4xl md:text-6xl leading-[1.05]"
        >
          Ready to Grow Your Business?
        </motion.h2>
        <p className="mt-5 text-lg text-white/60 max-w-xl mx-auto">
          Book a free funding consultation today. No obligations — just clear, honest guidance.
        </p>
        <div className="mt-9 flex flex-wrap gap-3 justify-center">
          <button data-testid="cta-book" onClick={() => scrollTo("contact")} className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-brand hover:bg-emerald text-white font-semibold transition-colors">
            <Calendar className="w-4 h-4" /> Book Meeting
          </button>
          <a data-testid="cta-whatsapp" href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-white/10 border border-white/15 text-white font-semibold hover:bg-white/20 transition-colors">
            <MessageCircle className="w-4 h-4" /> WhatsApp
          </a>
          <a data-testid="cta-call" href={`tel:${CONTACT.phoneRaw}`} className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-white/10 border border-white/15 text-white font-semibold hover:bg-white/20 transition-colors">
            <Phone className="w-4 h-4" /> Call
          </a>
        </div>
      </div>
    </section>
  );
};
